'use client';

import { App, ConfigProvider, theme } from 'antd';
import { themeDark, themeLite } from "@/theme/config/themeConfig";
import { useMemo } from "react";
import { useSession } from "next-auth/react";

// Spin.setDefaultIndicator(<NewSpinner />)

const AntdConfigProvider = ({ children}) => {
    const { data } = useSession()
    const { defaultAlgorithm, darkAlgorithm } = theme;

    const themeType = data ? data.themeType : 'light'

    const themSetting = useMemo(()=>{
        switch (themeType) {
            case 'light':
                return {
                    algorithm: defaultAlgorithm,
                    ...themeLite,
                }
            case 'dark':
                return {
                    algorithm: darkAlgorithm,
                    ...themeDark,
                }
            default:
                return {
                    algorithm: defaultAlgorithm,
                    ...themeLite,
                }

        }
    }, [themeType])

    return (
        <>
            <ConfigProvider
                theme={{
                    ...themSetting,
                    cssVar: { key: themeType }
                }}

            >
                <App className={`${themeType}_mode`}>
                    {children}
                </App>
            </ConfigProvider>
        </>
    );
}

export default AntdConfigProvider;